import { FormHandler } from '../../../../src/js/utils/form-handler';

document.addEventListener('DOMContentLoaded', () => {
	new FormHandler({
		formId: '4664177',
		turnstileSelector: '.sage-cf-turnstile',
	});
});
